
import { computed, defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'
import useAccount from '@/common/composable/useAccount'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const { havePermission } = useAccount()

        const tabsFiltered = computed(() => {
            const tabs: TabT[] = [
                { id: 1, name: 'Прокидывание заказов в 1С', path: '/one_c' },
                { id: 2, name: 'Переотправка в диспетчерскую', path: '/one_c/resend' },
                { id: 2, name: 'Переотправка рейсов', path: '/one_c/trips' },
            ]
            const tabSync = tabs.find((tab) => tab.id === 3)
            const tabDelivery = tabs.find((tab) => tab.id === 4)

            if (havePermission('sdt-order.index') && !tabSync) {
                tabs.push({
                    id: 3,
                    name: 'Отправка СДТ заказов',
                    path: '/one_c/sdt',
                })
            }

            if (havePermission('dispatcher.delivery-one-c') && !tabDelivery) {
                tabs.push({
                    id: 3,
                    name: 'Переотправка доставок',
                    path: '/one_c/delivery',
                })
            }

            return tabs
        })

        return { tabsFiltered }
    },
})
